import BasicCard from "../../components/card/BasicCard";
import cs from "../../assets/imgs/image6.jpg"
import sk from "../../assets/imgs/image5.jpg"
import jp from "../../assets/imgs/jpyngrope.jpeg"
import { useTheme } from "../../components/context/context";
import { Grid, Typography } from "@mui/material";


export default function KeyContacts(){
    const {fontSize} = useTheme();
    return(
        <div style={{ padding:"5px",margin:"20px 0", borderRadius:"2px"}}>
            <Typography variant="h5" sx={{color:"white", fontSize:`${fontSize}rem`, padding:"5px", background:"#0b4285"}}>Key Contacts</Typography>
            {/* <hr/> */}
            <Grid container gap={0.4} sx={{padding:"10px 0"}}>
                <Grid xs={12}>
                <BasicCard title={"Shri. Conrad Kongkal Sangma"} imgsrc={cs} description={<><span>Chief Minister of Meghalaya, Programme Implementation & Evaluation & </span> <a rel="noopener noreferrer" href="https://meghalaya.gov.in/index.php/key-contacts/council-of-ministers" target="_blank" style={{color:"black",fontSize: `${fontSize-0.3}rem`}}>Other Departments</a></>}/>
                </Grid>
                <Grid xs={12}>
                    <BasicCard title={"Shri. P. Sampath Kumar, IAS "} imgsrc={sk} description={"Principal Secretary, Programme Implementation & Evaluation Department"}/>
                </Grid>
                <Grid xs={12}>
                    <BasicCard title={"Shri. Jonathan Pyngrope"} imgsrc={jp} description={"Director, Meghalaya Society for Social Audit & Transparency (MSSAT)"}/>
                </Grid>

            </Grid>
        </div>
    )
}